import React from 'react'
import PropTypes from 'prop-types'
import { Spin } from 'antd'
import './spinner.scss'

const Spinner = ({
  size = 'default',
  tip,
  delay,
  fullScreen = false,
  className = '',
  ...props
}) => {
  const spinnerClass = `app-spinner ${fullScreen ? 'app-spinner-fullscreen' : ''} ${className}`

  return (
    <div className={spinnerClass}>
      <Spin size={size} tip={tip} delay={delay} {...props} />
    </div>
  )
}

Spinner.propTypes = {
  size: PropTypes.oneOf(['small', 'default', 'large']),
  tip: PropTypes.string,
  delay: PropTypes.number,
  fullScreen: PropTypes.bool,
  className: PropTypes.string
}

export default Spinner